import React from 'react';
import { NumericFormat } from 'react-number-format';
import './index.css';

const NumberFormatInput = (
  props,
  {
    name,
    required,
    type,
    placeholder,
    value,
    thousandSeparator,
    thousandsGroupStyle,
    onChange,
  }
) => {
  return (
    <NumericFormat
      name={name ? name : ''}
      required={required ? required : false}
      thousandSeparator={thousandSeparator ? thousandSeparator : false}
      autoComplete='off'
      thousandsGroupStyle={thousandsGroupStyle ? thousandsGroupStyle : ''}
      type={type ? type : 'text'}
      placeholder={placeholder ? placeholder : ''}
      className='NumberFormatInput'
      onChange={onChange}
      value={value ? value : ''}
      {...props}
    />
  );
};

export default NumberFormatInput;
